<script lang="ts">
  export let lastSold: { customer: string; eventName: string };
  export let className: string = "";
  const { customer, eventName } = lastSold;
</script>

<section class={`last-bougth grid ${className}`}>
  <h3 class="pf-700">Latest tickets sold</h3>
  <p class="sf-600">{customer}</p>
  <p class="sf-600">{eventName}</p>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .last-bougth {
    h3 {
      margin-bottom: 0.5em;
    }
    p {
      margin-bottom: 0.2em;
    }
    @include desktop {
      grid-template-columns: 1fr;
    }
  }
</style>
